(function () {
  const TIERS = [
    {
      id: 'tier_1',
      threshold: 1,
      short: '1. fornyelse',
      title: 'Første belønning',
      body: '- Velkomstgaver<br>- 10% på bag-in-box'
    },
    {
      id: 'tier_2',
      threshold: 2,
      short: '2. fornyelse',
      title: 'Streak fortsætter',
      body: '- 40 point = 40kr i partnerkredit<br>- 10% på bag-in-box.'
    },
    {
      id: 'tier_3',
      threshold: 3,
      short: '3. fornyelse',
      title: 'Streak fortsætter',
      body: '- 10% på bag-in-box<br>- Gratis levering fremover*<br><span style="font-size:12px; line-height:1.15; opacity:0.7; display:inline-block;">* Ved afhentning i butik<br>modtager du i stedet en gave.</span>'
    },
    {
      id: 'tier_4',
      threshold: 6,
      short: '6. fornyelse',
      title: 'Streak fortsætter',
      body: '- Overraskelsesgave<br>- Gratis levering<br>- 10% på bag-in-box'
    }
  ];

  function getTierLabel(tier, renewals) {
    if (!renewals || renewals === 0) {
      return 'Dine fordele aktiveres efter din første fornyelse.';
    }

    switch (tier) {
      case 'tier_1':
        return 'You’re on Tier 1 (1 renewal). Next perk unlocks at 3 renewals.';
      case 'tier_2':
        return 'You’re on Tier 2 (3 renewals). Next perk unlocks at 6 renewals.';
      case 'tier_3':
        return 'You’re on Tier 3 (6 renewals). Next perk unlocks at 12 renewals.';
      case 'tier_4':
        return 'You’re on Tier 4 (12+ renewals). You unlocked all streak perks.';
      default:
        return `Dit abonnement er blevet leveret ${renewals} gange.`;
    }
  }

  function getActiveIndex(currentTier, renewals) {
    const byId = TIERS.findIndex(t => t.id === currentTier);
    if (byId !== -1) return byId;

    let idx = -1;
    TIERS.forEach((t, i) => {
      if (renewals >= t.threshold) idx = i;
    });
    return idx === -1 ? 0 : idx;
  }

  function buildTimelineHtml(currentTier, renewals) {
    const activeIndex = getActiveIndex(currentTier, renewals);

    const stepsHtml = TIERS.map((tier, index) => {
      const reached = renewals >= tier.threshold;
      const active = index === activeIndex;

      const circleClass = [
        'streak-timeline__circle',
        reached ? 'streak-timeline__circle--reached' : '',
        active ? 'streak-timeline__circle--active' : ''
      ]
        .filter(Boolean)
        .join(' ');

      const statusClass = [
        'streak-timeline__status',
        reached ? 'streak-timeline__status--unlocked' : ''
      ]
        .filter(Boolean)
        .join(' ');

      const statusText = reached
        ? 'Låst op'
        : `Låst – ${Math.max(tier.threshold - renewals, 0)} fornyelser tilbage`;

      return `
        <div class="streak-timeline__step"
            data-streak-index="${index}"
            data-streak-active="${active}">
          <div class="${circleClass}">${tier.threshold}</div>
          <div class="streak-timeline__meta">
            <div class="streak-timeline__short">${tier.short}</div>
            <div class="streak-timeline__title">${tier.title}</div>
            <div class="streak-timeline__body">${tier.body}</div>
            <div class="${statusClass}">${statusText}</div>
          </div>
        </div>
      `;
    }).join('');

    return `
      <div class="streak-timeline">
        <div class="streak-timeline__track">
          <div class="streak-timeline__line">&nbsp;</div>
          <div class="streak-timeline__line streak-timeline__line--progress">&nbsp;</div>
          ${stepsHtml}
        </div>
      </div>
    `;
  }


  function renderStreakSection() {
    const data = window.appstleStreakData;
    if (!data) return false;

    const rewardsSection = document.querySelector(
      '.appstleLoyaltyPageV2RewardsSection'
    );
    if (!rewardsSection) return false;

    const { tier, renewals } = data;

    // 1) Update Appstle heading/subheading
    const headerTitle = rewardsSection.querySelector(
      '.appstleLoyaltyPageV2RewardsSectionHeaderTitle'
    );
    const headerSubtitle = rewardsSection.querySelector(
      '.appstleLoyaltyPageV2RewardsSectionHeaderSubtitle'
    );

    if (headerTitle) {
      headerTitle.textContent = 'Dine belønninger & streaks';
    }

    if (headerSubtitle) {
      if (!headerSubtitle.dataset.originalText) {
        headerSubtitle.dataset.originalText = headerSubtitle.textContent.trim();
      }
      const rewardsText = headerSubtitle.dataset.originalText;
      const streakText = getTierLabel(tier, renewals);
      headerSubtitle.textContent = `${rewardsText} · ${streakText}`;
    }

    // 2) Inject timeline before the rewards list
    const container = document.createElement('div');
    container.className = 'streak-timeline-wrapper';
    container.innerHTML = buildTimelineHtml(tier, renewals);

    const rewardsContainer = rewardsSection.querySelector(
      '.appstleLoyaltyPageV2RewardsContainer'
    );
    if (rewardsContainer && rewardsContainer.parentNode) {
      rewardsContainer.parentNode.insertBefore(container, rewardsContainer);
    } else {
      rewardsSection.appendChild(container);
    }

    // 3) Set progress bar width based on active step position
    const track = container.querySelector('.streak-timeline__track');
    const progressLine = container.querySelector('.streak-timeline__line--progress');
    const activeStep = container.querySelector('[data-streak-active="true"]');

    if (track && progressLine && activeStep) {
      if (renewals < TIERS[0].threshold) {
        // No renewals yet -> no progress
        progressLine.style.width = '0px';
      } else {
        const trackRect = track.getBoundingClientRect();
        const stepRect = activeStep.getBoundingClientRect();

        // distance from track left edge to center of active circle
        const progressPx =
          stepRect.left + stepRect.width / 2 - trackRect.left;

        progressLine.style.width = Math.max(0, progressPx) + 'px';
      }
    }

    // 4) On mobile, scroll the outer scroller to the active step
    const scroller = container.querySelector('.streak-timeline');
    if (scroller && activeStep && window.innerWidth < 768) {
      setTimeout(function () {
        const scrollerRect = scroller.getBoundingClientRect();
        const stepRect = activeStep.getBoundingClientRect();
        const offset =
          stepRect.left + stepRect.width / 2 -
          (scrollerRect.left + scrollerRect.width / 2);

        scroller.scrollLeft += offset;
      }, 100);
    }

    return true;

  }

  function tryRender() {
    if (!renderStreakSection()) {
      setTimeout(tryRender, 500);
    }
  }

  document.addEventListener('DOMContentLoaded', tryRender);
})();
